import { useMemo } from 'react'
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import styles from './MarkdownRenderer.module.css'

marked.setOptions({ breaks: true, gfm: true })

export function MarkdownRenderer({ content }: { content: string }) {
  const html = useMemo(() => {
    const rawHtml = marked.parse(content || '', { async: false }) as string
    return DOMPurify.sanitize(rawHtml)
  }, [content])

  if (!content?.trim()) {
    return <span style={{ color: 'var(--text-muted)', fontSize: 'var(--text-sm)' }}>Kein Inhalt.</span>
  }

  // html wurde bereits mit DOMPurify saniert (siehe oben) — XSS-Schutz für Markdown-Inhalte
  return <div className={styles.markdown} dangerouslySetInnerHTML={{ __html: html }} />
}
